import { useMutation } from "react-query";
import { loggedInApiSingleConcurrentCall } from "src/api/axiosClient/userApi";

export type DeleteProperty = {
    postId: number;
    propertyId: number;
    position?: number;
};
export const useDeleteProperty = () => {
    const query = useMutation({
        mutationFn: async (options: DeleteProperty) => {
            const { postId, propertyId, position = 0 } = options;

            return await loggedInApiSingleConcurrentCall.delete(
                `/api/ssq-posts/${postId}/property/${propertyId}/position/${position}`,
                {
                    headers: {
                        Accept: "application/json",
                    },
                },
            );
        },
        onSuccess: (result) => {},
    });

    return query;
};
